import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '60vh'
	}
}));

export default function Loading() {
	const classes = useStyles();
	return (
		<Box id="temp" className={classes.container}>
			<CircularProgress size={50} color="primary" className={classes.spinner} />
		</Box>
	);
}
